"use client";

import { Footer } from "@/providers/strapi/content/types/singleTypes/footer";
import { Header } from "@/providers/strapi/content/types/singleTypes/header";
// import * as X from "@/ui";
import { matchKey, PageHref, useMemo, usePathname } from "@/ui";

/**
 * Provides the current route in a logical way that allows knowing which menu
 * item to highlight.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function useRoute(_from?: string) {
  const path = usePathname();
  // console.log("PATH", path, from)
  return useMemo(() => {
    // if ((path as string) === "/ko/shipping") {
    //   return ["shipping"] as const;
    // }

    return matchKey(path, {
      /* --- traveler --- */
      "/": () => ["travelers", "home"] as const,
      "/faq": () => ["travelers", "faq"] as const,
      "/customer-service": () => ["travelers", "customerService"] as const,

      /* --- retail (NOTE: "order visibility kit" is in standalone section) --- */
      "/retail": () => ["retail", "home"] as const,
      "/retail/faq": () => ["retail", "faq"] as const,
      "/retail/customer-service": () => ["retail", "customerService"] as const,
      "/retail/become-partner": () => ["retail", "becomePartner"] as const,

      /* --- blog --- */
      "/blog": () => ["blog", "home"] as const,
      "/blog/[articleSlug]": () => ["blog", "article"] as const,
      "/blog/tag/[categorySlug]": () => ["blog", "category"] as const,
      "/blog/tag": () => ["blog", "all"] as const,

      /* --- about us --- */
      "/about-us": () => ["aboutUs"] as const,

      /* --- shipping --- */
      "/shipping": () => ["shipping"] as const,

      /* --- standalone --- */
      "/download": () => ["download"] as const,
      "/order-retailers": () => ["retail", "orderVisibilityKit"] as const,
      "/vat-refund-calculator": () => ["calculator"] as const,

      /* --- legal --- */
      "/privacy-policy": () => ["legal", "privacyPolicy"] as const,
      "/terms-and-conditions": () => ["legal", "termsAndConditions"] as const,
    });

  }, [path]);
}


type Route = ReturnType<typeof useRoute>;
//type Label = { [k in Locale]: React.ReactNode };
type RouteMatcher = (route: Route) => boolean;

//export type Menu = typeof menu;


type Section = {
  label: string;//Label;
  href: PageHref;
  match?: RouteMatcher;
  showMobile?: boolean;
  showFooter?: boolean;
  onlyFooter?: boolean;
  sub: {
    [k in string]: SectionSub;
  };
  cta?: string[]//{ fr: string, en: string }[]
};

type SectionSub = {
  label: string; //Label;
  href: PageHref;
  exitHref?: string;
  match?: (route: Route) => boolean;
  type?: "large" | "button";
  buttonPrimary?: boolean;
  buttonSecondary?: boolean;
  buttonTertiary?: boolean;
  showMobile?: boolean;
  showDesktop?: boolean;
};


// export const menu = {
//   "travelers": {
//     href: { pathname: "/" },
//     label: { en: "Travelers", fr: "Voyageurs" },
//     match: route => route[0] === "travelers" && route[1] !== "faq",
//     showMobile: true,
//     showFooter: true,
//     cta: [{ fr: "Télécharger l'application", en: "Download the app" }],
//     sub: {
//       "home": {
//         type: "large",
//         href: { pathname: "/" },
//         label: {
//           en: <><strong>Don&apos;t leave your VAT</strong> behind</>,
//           fr: <>La détaxe, <strong>aussi simple que votre shopping</strong></>,
//         },
//       },
//       "home#calculator": {
//         href: { pathname: "/", hash: "calculator" },
//         label: {
//           //en: "VAT refund calculator",
//           //fr: "Notre simulateur de détaxe",
//           en: "VAT Refund Simulator",
//           fr: "Simulateur de Détaxe",
//         },
//       },
//       "home#why": {
//         href: { pathname: "/", hash: "why" },
//         label: {
//           //en: "Why choose Zapptax",
//           //fr: "Pourquoi Zapptax",
//           en: "Why Zapptax",
//           fr: "Pourquoi Zapptax",
//         },
//       },
//       "home#testimonials": {
//         href: { pathname: "/", hash: "testimonials" },
//         label: {
//           //en: "What our users say",
//           //fr: "Nos utilisateurs parlent de nous",
//           en: "Customer Reviews",
//           fr: "Avis Clients",
//         },
//       },
//       "home#faq": {
//         href: { pathname: "/", hash: "faq" },
//         label: {
//           //en: "Top 5 most frequently asked questions",
//           //fr: "Nos top 5 des questions les plus fréquentes",
//           en: "FAQs",
//           fr: "FAQs",
//         },
//       },
//       //"faq": {
//       //href: { pathname: "/faq" },
//       //label: {
//       //en: "Full FAQ",
//       //fr: "Notre FAQ complète",
//       //},
//       //},
//       //"blog": {
//       //href: { pathname: "/blog" },
//       //label: {
//       //en: "Our blog",
//       //fr: "Notre blog",
//       //},
//       //},
//       "customer-service": {
//         href: { pathname: "/customer-service" },
//         label: {
//           //en: "Customer support",
//           //fr: "Notre service client",
//           en: "Customer Support",
//           fr: "Service Clients",
//         },
//       },
//     },
//   } as Section,

//   "retail": {
//     href: { pathname: "/retail" },
//     label: { en: "Retailers", fr: "Commerçants" },
//     match: route => route[0] === "retail" && route[1] !== "faq",
//     showMobile: true,
//     showFooter: true,
//     sub: {
//       "home": {
//         type: "large",
//         href: { pathname: "/retail" },
//         label: {
//           en: <>Tax-free shopping made easy. <strong>For you</strong> and <strong>your international customers</strong></>,
//           fr: <>La détaxe simplifiée, pour <strong>vous</strong> et <strong>vos clients internationaux</strong></>,
//         },
//       },
//       "demo": {
//         href: { pathname: "/retail/become-partner" },
//         label: {
//           //en: "See our demo",
//           //fr: "Notre démo parle d'elle-même",
//           en: "Become a Partner",
//           fr: "Devenir Partenaire",
//         },
//       },
//       "#why": {
//         href: { pathname: "/retail", hash: "why" },
//         label: {
//           //en: "Why Zapptax for your business?",
//           //fr: "Pourquoi Zapptax pour votre commerce ?",
//           en: "Why Zapptax",
//           fr: "Pourquoi Zapptax",
//         },
//       },
//       "#testimonials": {
//         href: { pathname: "/retail", hash: "testimonials" },
//         label: {
//           //en: "Trusted by many",
//           //fr: "Ils nous font déjà confiance",
//           en: "Partners Testimonials",
//           fr: "Avis Partenaires",
//         },
//       },
//       "#faq": {
//         href: { pathname: "/retail", hash: "faq" },
//         label: {
//           //en: "Top 5 most frequently asked questions",
//           //fr: "Nos top 5 des questions les plus fréquentes",
//           en: "FAQs",
//           fr: "FAQs",
//         },
//       },
//       //"faq": {
//       //href: { pathname: "/retail/faq" },
//       //label: {
//       //en: "Full FAQ",
//       //fr: "Notre FAQ complète",
//       //},
//       //},
//       //"blog": {
//       //href: { pathname: "/blog" },
//       //label: {
//       //en: "Our blog",
//       //fr: "Notre blog",
//       //},
//       //},
//       "customer-service": {
//         href: { pathname: "/retail/customer-service" },
//         label: {
//           //en: "Customer support",
//           //fr: "Notre service client",
//           en: "Customer Support",
//           fr: "Service Clients",
//         },
//       },
//     },
//   } as Section,

//   "shipping": {
//     label: { en: "Shipping", fr: "Shipping" },
//     href: { pathname: "/shipping" },
//     showFooter: true,
//     onlyFooter: true,
//     sub: {
//       "home": {
//         type: "large",
//         href: { pathname: "/shipping" },
//         label: {
//           en: <strong>Shop in Europe, ship worldwide - without VAT!</strong>,
//           fr: <strong>Vos achats en Europe, livrés partout dans le monde… sans la TVA !</strong>,
//         },
//       },
//       "homeTry": {
//         href: { pathname: "/shipping" },
//         label: {
//           en: "Try Zapptax Shipping",
//           fr: "Essayez Zapptax Shipping",
//         },
//       },
//       "#who": {
//         href: { pathname: "/shipping", hash: "who" },
//         label: {
//           en: "Who can use Zapptax Shipping?",
//           fr: "À qui s’adresse Zapptax Shipping ?",
//         },
//       },
//       "#pricing": {
//         href: { pathname: "/shipping", hash: "pricing" },
//         label: {
//           en: "What are the fees?",
//           fr: "Quels sont les frais ?",
//         },
//       },
//       "#contact": {
//         href: { pathname: "/shipping", hash: "contact" },
//         label: {
//           en: "A customer service that’s human, helpful, and responsive",
//           fr: "Un service client à votre écoute, humain et réactif",
//         },
//       },
//     },
//   } as Section,

//   "aboutUs": {
//     label: { en: "About Zapptax", fr: "Qui est Zapptax" },
//     href: { pathname: "/about-us" },
//     showMobile: true,
//     showFooter: true,
//     sub: {
//       "story": {
//         href: { pathname: "/about-us" },
//         label: {
//           en: "Our Story",
//           fr: "Notre Histoire",
//         },
//       },
//       "#mission": {
//         href: { pathname: "/about-us", hash: "mission" },
//         label: {
//           en: "Our Mission",
//           fr: "Notre Mission",
//         },
//       },
//       "#values": {
//         href: { pathname: "/about-us", hash: "values" },
//         label: {
//           en: "Our Values",
//           fr: "Nos Valeurs",
//         },
//       },
//       "#join": {
//         href: { pathname: "/about-us", hash: "join" },
//         label: {
//           //en: "Join the team",
//           //fr: "Rejoignez l'équipe",
//           en: "Jobs",
//           fr: "Jobs",
//         },
//       },
//       "#commitments": {
//         href: { pathname: "/about-us", hash: "commitments" },
//         label: {
//           en: "Our Commitments",
//           fr: "Nos Engagements",
//         },
//       },
//       //"#resources": {
//       //href: { pathname: "/about-us", hash: "resources" },
//       //label: {
//       //en: "Our resources",
//       //fr: "Nos ressources",
//       //},
//       //},
//     },
//   } as Section,

//   "blog": {
//     label: { en: "Blog", fr: "Blog" },
//     href: { pathname: "/blog" },
//     sub: {
//     },
//   } as Section,

//   "faq": {
//     href: { pathname: "/faq" },
//     label: { en: "FAQs", fr: "FAQs" },
//     match: route => (route[0] === "travelers" || route[0] === "retail") && route[1] === "faq",
//     sub: {
//       "travelers": {
//         href: { pathname: "/faq" },
//         label: {
//           //en: "Travelers FAQ - all your questions answered",
//           //fr: "Notre FAQ complète pour les voyageurs",
//           en: "FAQs Travelers",
//           fr: "FAQs Voyageurs",
//         },
//       },
//       "retailers": {
//         href: { pathname: "/retail/faq" },
//         label: {
//           //en: "Retailers FAQ - all your questions answered",
//           //fr: "Notre FAQ complète pour les commerçants",
//           en: "FAQs Retailers",
//           fr: "FAQs Commerçants",
//         },
//       },
//     },
//   } as Section,

// } satisfies {
//   [k in string]: Section;
// };
export type MenuSection = keyof Menu;
type Menu = {
  "travelers": Section;
  retail: Section;
  // shipping: Section;
  aboutUs: Section;
  blog: Section;
  faq: Section;
}
type MenuType = {
  [k in MenuSection]: Section;
}


export const buildMenu = (header: Header): MenuType => ({

  "travelers": {
    href: { pathname: "/" },
    label: header.travelerNavigation.label,
    cta: [header.travelerNavigation.downloadCta,],
    match: route => route[0] === "travelers" && route[1] !== "faq",
    showMobile: true,
    showFooter: true,
    sub: {
      "home": {
        type: "large",
        href: { pathname: "/" },
        label: header.travelerNavigation.mainLink
        // label: {
        //   en: <ReactMarkdown >
        //     {header.travelerNavigation.mainLink}
        //   </ReactMarkdown>,
        //   fr: <ReactMarkdown >
        //     {header.travelerNavigation.mainLink}
        //   </ReactMarkdown>,
        // },
      },
      "home#calculator": {
        href: { pathname: "/", hash: "calculator" },
        label: header.travelerNavigation.link1
      },
      "home#why": {
        href: { pathname: "/", hash: "why" },
        label: header.travelerNavigation.link2,
      },
      "home#testimonials": {
        href: { pathname: "/", hash: "testimonials" },
        label: header.travelerNavigation.link3,
      },
      "home#faq": {
        href: { pathname: "/", hash: "faq" },
        label: header.travelerNavigation.link4,
      },
      "customer-service": {
        href: { pathname: "/customer-service" },
        label: header.travelerNavigation.link5,
      },
    },
  } as Section,

  "retail": {
    href: { pathname: "/retail" },
    label: header.shopNavigation.label,
    match: route => route[0] === "retail" && route[1] !== "faq",
    showMobile: true,
    showFooter: true,
    cta: [
      header.shopNavigation.becomePartnerCta,
      header.shopNavigation.loginCta
    ],
    sub: {
      "home": {
        type: "large",
        href: { pathname: "/retail" },
        label: header.shopNavigation.mainLink,
        // label: {
        //   en: <ReactMarkdown >
        //     {header.shopNavigation.mainLink}
        //   </ReactMarkdown>,
        //   fr: <ReactMarkdown >
        //     {header.shopNavigation.mainLink}
        //   </ReactMarkdown>,
        // },
      },
      "demo": {
        href: { pathname: "/retail/become-partner" },
        label: header.shopNavigation.link1,
      },
      "#why": {
        href: { pathname: "/retail", hash: "why" },
        label: header.shopNavigation.link2,
      },
      "#testimonials": {
        href: { pathname: "/retail", hash: "testimonials" },
        label: header.shopNavigation.link3,
      },
      "#faq": {
        href: { pathname: "/retail", hash: "faq" },
        label: header.shopNavigation.link4,
      },
      "customer-service": {
        href: { pathname: "/retail/customer-service" },
        label: header.shopNavigation.link5
      },
    },
  } as Section,

  // "shipping": {
  //   label: "Shipping",
  //   href: { pathname: "/shipping" },
  //   showFooter: true,
  //   onlyFooter: true,
  //   sub: {
  //     "home": {
  //       type: "large",
  //       href: { pathname: "/shipping" },
  //       label: "Shop in Europe, ship worldwide - without VAT!",
  //       // label: "{
  //       //   en: <strong>Shop in Europe, ship worldwide - without VAT!</strong>,
  //       //   fr: <strong>Vos achats en Europe, livrés partout dans le monde… sans la TVA !</strong>,
  //       // },"
  //     },
  //     "homeTry": {
  //       href: { pathname: "/shipping" },
  //       label: "Try Zapptax Shipping",
  //       // label: {
  //       //   en: "Try Zapptax Shipping",
  //       //   fr: "Essayez Zapptax Shipping",
  //       // },
  //     },
  //     "#who": {
  //       href: { pathname: "/shipping", hash: "who" },
  //       label: "Who can use Zapptax Shipping?",
  //       // label: {
  //       //   en: "Who can use Zapptax Shipping?",
  //       //   fr: "À qui s’adresse Zapptax Shipping ?",
  //       // },
  //     },
  //     "#pricing": {
  //       href: { pathname: "/shipping", hash: "pricing" },
  //       // label: {
  //       //   en: "What are the fees?",
  //       //   fr: "Quels sont les frais ?",
  //       // },
  //       label: "What are the fees?",
  //     },
  //     "#contact": {
  //       href: { pathname: "/shipping", hash: "contact" },
  //       label: "Un service client à votre écoute, humain et réactif"
  //       // label: {
  //       //   en: "A customer service that’s human, helpful, and responsive",
  //       //   fr: "Un service client à votre écoute, humain et réactif",
  //       // },
  //     },
  //   },
  // } as Section,

  "aboutUs": {
    label: header.aboutUsNavigation.label,
    href: { pathname: "/about-us" },
    showMobile: true,
    showFooter: true,
    sub: {
      "story": {
        href: { pathname: "/about-us" },
        label: header.aboutUsNavigation.link1,
      },
      "#mission": {
        href: { pathname: "/about-us", hash: "mission" },
        label: header.aboutUsNavigation.link2,
      },
      "#values": {
        href: { pathname: "/about-us", hash: "values" },
        label: header.aboutUsNavigation.link3,
      },
      "#join": {
        href: { pathname: "/about-us", hash: "join" },
        label: header.aboutUsNavigation.link4,
      },
      "#commitments": {
        href: { pathname: "/about-us", hash: "commitments" },
        label: header.aboutUsNavigation.link5,
      },
      //"#resources": {
      //href: { pathname: "/about-us", hash: "resources" },
      //label: {
      //en: "Our resources",
      //fr: "Nos ressources",
      //},
      //},
    },
  } as Section,

  "blog": {
    label: header.blogNavigation.label,//"Blog",
    href: { pathname: "/blog" },
    sub: {
    },
  } as Section,

  "faq": {
    href: { pathname: "/faq" },
    // label: { en: "FAQs", fr: "FAQs" },
    label: header.faqsNavigation.label,//"Faqs",
    match: route => (route[0] === "travelers" || route[0] === "retail") && route[1] === "faq",
    sub: {
      "travelers": {
        href: { pathname: "/faq" },
        //label: "FAQs Voyageurs",
        label: header.faqsNavigation.link1
        // label: {
        //   //en: "Travelers FAQ - all your questions answered",
        //   //fr: "Notre FAQ complète pour les voyageurs",
        //   en: "FAQs Travelers",
        //   fr: "FAQs Voyageurs",
        // },
      },
      "retailers": {
        href: { pathname: "/retail/faq" },
        // label: "FAQs Commerçants",
        label: header.faqsNavigation.link2
        // label: {
        //   //en: "Retailers FAQ - all your questions answered",
        //   //fr: "Notre FAQ complète pour les commerçants",
        //   en: "FAQs Retailers",
        //   fr: "FAQs Commerçants",
        // },
      },
    },
  } as Section,


});

export type FooterSection = keyof FooterModel
type FooterModel = {
  "travelers": Section;
  retail: Section;
  shipping: Section;
  aboutUs: Section;
}
type FooterType = {
  [k in FooterSection]: Section;
}

export const buildFooter = (header: Footer): FooterType => ({

  "travelers": {
    href: { pathname: "/" },
    label: header.travelersNavigation.label,
    cta: [''],
    match: route => route[0] === "travelers" && route[1] !== "faq",
    showMobile: true,
    showFooter: true,
    sub: {
      "home": {
        type: "large",
        href: { pathname: "/" },
        label: header.travelersNavigation.mainLink,
        // label: {
        //   en: <ReactMarkdown >
        //     {header.travelersNavigation.mainLink}
        //   </ReactMarkdown>,
        //   fr: <ReactMarkdown >
        //     {header.travelersNavigation.mainLink}
        //   </ReactMarkdown>,
        // },
      },
      "home#calculator": {
        href: { pathname: "/", hash: "calculator" },
        label: header.travelersNavigation.link1
      },
      "home#why": {
        href: { pathname: "/", hash: "why" },
        label: header.travelersNavigation.link2,
      },
      "home#testimonials": {
        href: { pathname: "/", hash: "testimonials" },
        label: header.travelersNavigation.link3,
      },
      "home#faq": {
        href: { pathname: "/", hash: "faq" },
        label: header.travelersNavigation.link4,
      },
      "customer-service": {
        href: { pathname: "/customer-service" },
        label: header.travelersNavigation.link5,
      },
    },
  } as Section,

  "retail": {
    href: { pathname: "/retail" },
    label: header.shopsNavigation.label,
    match: route => route[0] === "retail" && route[1] !== "faq",
    showMobile: true,
    showFooter: true,
    cta: ["", ""],
    sub: {
      "home": {
        type: "large",
        href: { pathname: "/retail" },
        label: header.shopsNavigation.mainLink,
        // label: {
        //   en: <ReactMarkdown >
        //     {header.shopsNavigation.mainLink}
        //   </ReactMarkdown>,
        //   fr: <ReactMarkdown >
        //     {header.shopsNavigation.mainLink}
        //   </ReactMarkdown>,
        // },
      },
      "demo": {
        href: { pathname: "/retail/become-partner" },
        label: header.shopsNavigation.link1
      },
      "#why": {
        href: { pathname: "/retail", hash: "why" },
        label: header.shopsNavigation.link2,
      },
      "#testimonials": {
        href: { pathname: "/retail", hash: "testimonials" },
        label: header.shopsNavigation.link3,
      },
      "#faq": {
        href: { pathname: "/retail", hash: "faq" },
        label: header.shopsNavigation.link4,
      },

      "customer-service": {
        href: { pathname: "/retail/customer-service" },
        label: header.shopsNavigation.link5,
      },
    },
  } as Section,

  "shipping": {
    label: header.shippingNavigation.label,
    href: { pathname: "/shipping" },
    showFooter: true,
    onlyFooter: true,
    sub: {
      "home": {
        type: "large",
        href: { pathname: "/shipping" },
        label: header.shippingNavigation.mainLink,
      },
      "homeTry": {
        href: { pathname: "/shipping" },
        label: header.shippingNavigation.link1,
      },
      "#who": {
        href: { pathname: "/shipping", hash: "who" },
        label: header.shippingNavigation.link2,
      },
      "#pricing": {
        href: { pathname: "/shipping", hash: "pricing" },
        label: header.shippingNavigation.link3,
      },
      "#contact": {
        href: { pathname: "/shipping", hash: "contact" },
        label: header.shippingNavigation.link4,
      },
    },
  } as Section,

  "aboutUs": {
    label: header.aboutUsNavigation.label,
    href: { pathname: "/about-us" },
    showMobile: true,
    showFooter: true,
    sub: {
      "story": {
        href: { pathname: "/about-us" },
        label: header.aboutUsNavigation.link1,
      },
      "#mission": {
        href: { pathname: "/about-us", hash: "mission" },
        label: header.aboutUsNavigation.link2,
      },
      "#values": {
        href: { pathname: "/about-us", hash: "values" },
        label: header.aboutUsNavigation.link3,
      },
      "#join": {
        href: { pathname: "/about-us", hash: "join" },
        label: header.aboutUsNavigation.link4,
      },
      "#commitments": {
        href: { pathname: "/about-us", hash: "commitments" },
        label: header.aboutUsNavigation.link5,
      },
      //"#resources": {
      //href: { pathname: "/about-us", hash: "resources" },
      //label: {
      //en: "Our resources",
      //fr: "Nos ressources",
      //},
      //},
    },
  } as Section,

  // "blog": {
  //   label: "Blog",
  //   href: { pathname: "/blog" },
  //   sub: {
  //   },
  // } as Section,

  // "faq": {
  //   href: { pathname: "/faq" },
  //   label: "FAQs",
  //   match: route => (route[0] === "travelers" || route[0] === "retail") && route[1] === "faq",
  //   sub: {
  //     "travelers": {
  //       href: { pathname: "/faq" },
  //       label: "FAQs Voyageurs",
  //     },
  //     "retailers": {
  //       href: { pathname: "/retail/faq" },
  //       label: "FAQs Retailers",
  //     },
  //   },
  // } as Section,


});
